import React from 'react';
import {useParams} from 'react-router-dom';
import {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {FormsOfflineBoundary} from 'src/app/forms/FormsOfflineBoundary';
import {FormsPendingSyncBanner} from 'src/app/forms/offline/FormsPendingSyncBanner';
import {BackBar} from 'src/app/layout/BackBar';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {FormSubmissionsTable} from 'src/pages/Modules/Forms/shared/FormSubmissionsTable/FormSubmissionsTable';
import UnhandledErrorPage from 'src/pages/Common/UnhandledError/UnhandledError.page';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {useGetFormDefinitionQuery} from 'src/redux/queries/formDefinition';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useFormsBreadcrumbs} from 'src/shared/hooks/useFormsBreadcrumbs';
import {FormDocumentTitle} from '../../../../../app/forms/formHelpers';

const FormsListPage: React.FC = () => {
  useSetDocumentTitle(FormDocumentTitle);
  const {formDefinitionId} = useParams();

  const {data: formDefinition} = useGetFormDefinitionQuery(
    Number(formDefinitionId),
    {skip: !formDefinitionId || isNaN(Number(formDefinitionId))}
  );

  const {breadcrumbs, fallbackTo} = useFormsBreadcrumbs({
    mode: 'form-list',
    formDefinitionId,
    formDefinitionName: formDefinition?.name,
  });

  if (!formDefinitionId || isNaN(Number(formDefinitionId))) {
    return <UnhandledErrorPage error="Invalid form definition ID" />;
  }

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Forms}>
      <BackBar fallbackTo={fallbackTo} breadcrumbs={breadcrumbs} />
      <FormsPendingSyncBanner />
      <FormSubmissionsTable
        identifier="selected-form-submissions"
        formDefinitionId={Number(formDefinitionId)}
      />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.FormsList(':formDefinitionId'),
  element: (
    <FormsOfflineBoundary>
      <FormsListPage />
    </FormsOfflineBoundary>
  ),
  isPrivate: true,
  supportsOffline: true,
});

export default FormsListPage;
